import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { useDynamicText } from '../../contexts/DynamicTextContext';

interface DynamicTextProps extends Omit<TypographyProps, 'children'> {
    text: string;
}

export const DynamicText = ({ text, ...props }: DynamicTextProps) => {
    const { processText } = useDynamicText();
    const processedText = processText(text);

    return (
        <Typography {...props}>
            {processedText}
        </Typography>
    );
}; 